export default "__VITE_ASSET__BRICV0XO__"